import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BlockUIModule } from 'primeng/blockui';
import { MxEnsureModuleLoadedOnceGuard } from '../../mx.ensure-module-loaded-once.guard';

import { MxOverlayRequestResponseInterceptor } from './mx.overlay-request-response.interceptor';
import { MxOverlayComponent } from './mx.overlay.component';

@NgModule({
  imports: [CommonModule, BlockUIModule],
  exports: [MxOverlayComponent],
  declarations: [MxOverlayComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MxOverlayRequestResponseInterceptor,
      multi: true,
    },
  ],
})
export class MxOverlayModule extends MxEnsureModuleLoadedOnceGuard {
  // Ensure that OverlayModule is only loaded into AppModule

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: MxOverlayModule) {
    super(parentModule, 'CoreModule');
  }
}
